










import {Vue, Component, Prop} from "vue-property-decorator";

@Component
export default class QuestionTooltip extends Vue {
    @Prop() private tooltip!: string | null;
}
